function Footer() {
  return (
    <footer className="container-fluid footer">
      <p className="col-md-4 col-sm-12">&copy; {new Date().getFullYear()} POLSAN TEKNOKENT. Tüm hakları saklıdır.</p>
      <div className="col-md-8 col-sm-12 justify-content-md-end d-flex">
        <div className="row">
          <span className="col-md-auto col-sm-12"><i className="bi bi-envelope footer-icon"></i> <a href="mailto:info@polsanteknokent.com.tr">info@polsanteknokent.com.tr</a></span>
          <span className="col-md-auto col-sm-12"><i className="bi bi-telephone footer-icon"></i> <a href="tel:+902162101842">+90 216 210 18 42</a></span>
          <span className="col-md-auto col-sm-12"> <a href="https://tr.linkedin.com/company/polsan-teknokent-y%C3%B6netim-a-%C5%9F" target="_blank" rel="noopener"><i className="bi bi-linkedin footer-icon"></i></a></span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;